import type { OutboundEmailFields } from '../components/CatoContainer/Pages/Email/Outbound/EmailOutboundHeader';
import { EmailContactData } from '../models/EmailContact';
import { EMAIL_REGEX } from './regex';

// The amazon-connect-streams type definitions don't include emailAddress on endpoint
// This interface encapsulates the shape until the types are updated upstream.

interface EmailEndpoint {
  emailAddress?: string;
  // The type definition exposes 'name' but the runtime object uses 'displayName'
  displayName?: string;
}

// The amazon-connect-streams type definitions declare 'valueString' but the runtime
// uses 'ValueString'
interface SegmentAttributeValue {
  ValueString?: string;
}

export const extractEmailData = (contact: connect.Contact): EmailContactData => {
  const contactId = contact.getContactId();
  const segmentAttributes = contact.getSegmentAttributes();

  const customerName = (contact.getCustomerEndpoint() as EmailEndpoint)?.displayName;
  const from = (contact.getCustomerEndpoint() as EmailEndpoint)?.emailAddress;
  const systemEndpoint = contact.getConnectSystemEndpoint();
  const toAddress = (systemEndpoint as EmailEndpoint)?.emailAddress;
  const to = toAddress ? [toAddress] : undefined;
  const subject = (segmentAttributes['connect:EmailSubject'] as SegmentAttributeValue)?.ValueString;
  const receivedAt = contact.getState().timestamp?.toISOString();

  const initiationMethod = contact.getInitiationMethod() ?? undefined;

  return { contactId, customerName, from, to, subject, receivedAt, initiationMethod };
};

export const formatReceivedAt = (iso: string): string => {
  const date = new Date(iso);
  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();

  const day = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

  return isToday ? `Today, ${day} at ${time}` : `${day} at ${time}`;
};

export const formatBodyPreview = (html: string): string => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent ?? div.innerText ?? '').trim();
};

export const processEmailHtml = (html: string): string => {
  return html.replace(/<img /gi, '<img referrerpolicy="no-referrer" ');
};

export const isOutboundFieldsValid = (fields: OutboundEmailFields): boolean => {
  return EMAIL_REGEX.test(fields.to.trim()) && fields.subject.trim() !== '';
};
